import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router';

import { CvSearchSyncProblemDto } from '@/api/generated';
import { cvSearchSyncStatusStyles as styles } from '@/layouts/private/topBar/components/cvSearchSyncStatus/CvSearchSyncStatus.styles.ts';
import { cvSearchSyncStatusUtil } from '@/layouts/private/topBar/components/cvSearchSyncStatus/utils/cvSearchSyncStatus.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type Props = {
  onNavigate: () => void;
  problem: CvSearchSyncProblemDto;
};

export const CvSearchSyncStatusDrawerProblem: React.FC<Props> = ({ onNavigate, problem }) => {
  const { t } = useTranslationWithPrefix('layouts.cvSearchSyncStatus.problems');
  const category = `categories.${problem.category}`;

  return (
    <Accordion disabled={problem.count === 0} disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ flexGrow: 1 }} variant="f14Medium">
          {t(`${category}.title`)}
        </Typography>
        <Typography sx={{ mr: 1 }} variant="f14Medium">
          {problem.count}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={1}>
          <Typography variant="f12Regular">{t(`${category}.description`)}</Typography>
          {problem.items.map(item => {
            const link = cvSearchSyncStatusUtil.candidateLink(item);
            const label = cvSearchSyncStatusUtil.candidateLabel(item);
            return (
              <Stack key={item.documentId}>
                {link ? (
                  <Link component={RouterLink} onClick={onNavigate} to={link} variant="f14Regular">
                    {label}
                  </Link>
                ) : (
                  <Typography variant="f14Regular">{label}</Typography>
                )}
                {item.detail && (
                  <Typography sx={styles.itemDetail} variant="f12Regular">
                    {item.detail}
                  </Typography>
                )}
              </Stack>
            );
          })}
          {problem.count > problem.items.length && (
            <Typography variant="f12Regular">
              {t('shown', { count: problem.count, shown: problem.items.length })}
            </Typography>
          )}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
